// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7u1K5","banner__texto":"Banner_banner__texto__rWb7i"};